import clsx from "clsx";
import { ChatMessage as ChatMessageType } from "api/chat";

interface ChatMessageProps {
  message: ChatMessageType;
}

export default function ChatMessage({
  message
}: ChatMessageProps): JSX.Element {
  const isUser = message.role === "user";

  return (
    <div className={clsx("max-w-[80%] mb-4", isUser ? "ml-auto" : "mr-auto")}>
      <div
        className={clsx(
          "chat-message px-4 py-3 rounded-lg",
          isUser
            ? "bg-secondary-50 text-white"
            : "bg-gray-100 text-emphasis-high"
        )}
      >
        {isUser ? (
          <p className="m-0 text-base">{message.message}</p>
        ) : (
          <p
            className="m-0 text-base"
            dangerouslySetInnerHTML={{ __html: message.message }}
          />
        )}
      </div>
    </div>
  );
}
